// Updates or replaces a paramter on the query string.
function updateQueryStringParameter(uri, key, value) {
  if (typeof value === 'undefined') {
    value = '';
  }
  var re = new RegExp('([?|&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
}

module.exports = updateQueryStringParameter;
